module.exports = __webpack_public_path__ + "img/image34.42e19b6f.webp";